export default __webpack_public_path__ + "static/media/vertical-ceiling.3fd843d5.png";